"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxList/PinLimitToast.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

const SHOW_FOR_MS = 5000

// The text to show, and the call that shows it for a few seconds.
 const usePinLimitToast = () => {
  const [pinLimitText, setPinLimitText] = _react.useState(null)
  const timerRef = _react.useRef(undefined)
  const showPinLimit = _react.useCallback.call(void 0, (text) => {
    clearTimeout(timerRef.current)
    setPinLimitText(text)
    timerRef.current = setTimeout(() => setPinLimitText(null), SHOW_FOR_MS)
  }, [])
  _react.useEffect.call(void 0, () => () => clearTimeout(timerRef.current), [])
  return { pinLimitText, showPinLimit }
}; exports.usePinLimitToast = usePinLimitToast

// The pin limit (D-12): the conversation's dark toast, with no Undo, at the
// bottom of the list column. The live region stays mounted so screen
// readers hear the text when it appears.
const PinLimitToast = ({ text }) => (
  _react2.default.createElement('div', { className: "scheduled-cancel-toast--anchor inbox-list--toast" , role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
    , text && _react2.default.createElement('div', { className: "scheduled-cancel-toast inbox-list--toast-text" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}, text)
  )
)

exports. default = _react.memo.call(void 0, PinLimitToast)
